<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <AdminResetForm />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import AdminResetForm from '@/components/admin/AdminResetForm.vue'

export default {
    name: 'AdminReset',
    components: {
        Header,
        Footer,
        AdminResetForm,
    },
}
</script>